import { i18n } from '@/config/i18n'
import { StringMap } from '../utils/map'
import { environmentConfiguration } from '@/config/environments'
import { SeoInformation } from '@/shared/models/seo-information'
import { translate } from '@/shared/utils/branded-translation'

export class MetaService {
  config = environmentConfiguration()

  private metaTags = [
    'og:description',
    'og:image',
    'og:site_name',
    'og:title',
    'og:type',
    'og:url',
    'twitter:card',
    'twitter:creator',
    'twitter:description',
    'twitter:image',
    'twitter:site',
    'twitter:title',
  ]

  public removeMetaTags(): void {
    for (const key of this.metaTags) {
      const metaTag =
        document.querySelector(`meta[property="${key}"]`) ??
        document.querySelector(`meta[name="${key}"]`)

      if (metaTag) {
        metaTag.parentNode?.removeChild(metaTag)
      }
    }
  }

  public updateDocumentTitle(name?: string, params: StringMap<string> = { name: '' }) {
    let title: string

    if (name !== undefined) {
      const i18nKey = `routes.${name}`
      const template: string = translate('routes.template') as string
      const route: string = translate(`routes.${name}`, params) as string

      if (route !== i18nKey) {
        // Translation exists
        title = template.replace('{}', route)
      } else {
        title = template.replace('{}', name)
      }
    } else {
      title = 'respondeco.org'
    }

    document.title = title
  }

  public updateSeo(information: SeoInformation) {
    const siteName = i18n.t(
      'branding.' + environmentConfiguration().branding ?? 'respondeco'
    ) as string

    const metaInformation = {
      'og:description': information.description,
      'og:image': information.image + '?height=1200&width=1200&crop=false',
      'og:site_name': siteName,
      'og:title': document.title,
      'og:type': 'website',
      'og:url': location.href,
      'twitter:card': 'summary_image',
      'twitter:creator': information.creator,
      'twitter:description': information.description,
      'twitter:image': information.image + '?height=800&width=800&crop=false',
      'twitter:site': siteName,
      'twitter:title': document.title,
    }

    Object.entries(metaInformation).forEach(([key, value]) => {
      let metaElement =
        document.querySelector(`meta[property="${key}"]`) ??
        document.querySelector(`meta[name="${key}"]`)

      if (metaElement != null) {
        if (value == null) {
          metaElement.parentNode?.removeChild(metaElement)
        } else {
          metaElement.setAttribute('content', value)
        }
      } else if (value) {
        metaElement = document.createElement('meta')

        metaElement.setAttribute(key.startsWith('twitter') ? 'name' : 'property', key)
        metaElement.setAttribute('content', value)

        document.head.appendChild(metaElement)
      }
    })
  }
}
